import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';

import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Modal,
  OutlinedInput,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API } from '../../config/API';
import { setUser } from '../../store/action';
import swal from 'sweetalert';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  maxWidth: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 3
};

const ModalEditProfil = (props) => {
  const [proses, setProses] = useState(false)
  const [nama, setNama] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [nameError, setNameError] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)


  useEffect(() => {
    setNama(props.userProfile.name || '')
    setEmail(props.userProfile.email || '')
    setPhone(props.userProfile.phone_number || '')
  }, [props.userProfile])

  const validateForm = () => {
    let isError = false
    if (!nama) {
      setNameError(true)
      isError = true
    }
    else setNameError(false)

    if (!email) {
      setEmailError(true)
      isError = true
    }
    else setEmailError(false)

    if (!phone) {
      setPhoneError(true)
      isError = true
    }
    else setPhoneError(false)

    return isError
  }

  const submit = async (e) => {
    e.preventDefault();

    setProses(true)
    if (await !validateForm()) {
      try {
        let token = Cookies.get('token_fkub')

        let newInfo = {
          name: nama,
          email: email,
          phone_number: phone,
        }

        await API.put(`/api/v1/user/${props.userProfile._id}/information`, newInfo, { headers: { token: `Bearer ${token}` } })

        await props.setUser({
          ...props.userProfile,
          email,
          name: nama,
          phone_number: phone
        })
        swal("Berhasil", "Ubah data berhasil!", "success");
        props.onClose()
      } catch (err) {
        // console.log(err)
        swal("Error", "Please try again!", "error");
      }
    }
    setProses(false)
  }

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ p: '16px 24px', borderBottom: '0.5px solid #aaa', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography id="modal-modal-title" variant="h6" style={{ fontWeight: 'bold' }}>
            Ubah Akun
          </Typography>
          <CloseIcon style={{ cursor: 'pointer' }} onClick={props.onClose} />
        </Box>
        <Box component="form" noValidate>
          <Box sx={{ p: '32px 24px' }}>
            <FormControl sx={{ width: '100%', mb: '24px' }} variant="outlined" size="small" required error={nameError}>
              <InputLabel>Nama</InputLabel>
              <OutlinedInput variant="outlined"
                value={nama}
                onChange={(e) => setNama(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="Nama"
              />
            </FormControl>

            <FormControl sx={{ width: '100%', mb: '24px' }} variant="outlined" size="small" required error={emailError}>
              <InputLabel>E-mail</InputLabel>
              <OutlinedInput variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="E-mail"
              />
            </FormControl>
            <FormControl sx={{ width: '100%' }} variant="outlined" size="small" required error={phoneError}>
              <InputLabel>Nomor Telepon</InputLabel>
              <OutlinedInput variant="outlined"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{ width: '100%' }}
                disabled={proses}
                label="Nomor Telepon"
              />
            </FormControl>
          </Box>
          <Box sx={{ textAlign: 'right', mb: 2, px: 3 }}>
            <Button sx={{ color: 'black', textTransform: 'none', mr: 3 }} onClick={props.onClose}>Batal</Button>
            <Button type="submit" variant="contained" style={{ backgroundColor: '#9F0102', color: 'white', textTransform: 'none' }} onClick={submit}>Simpan Perubahan</Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

const mapDispatchToProps = {
  setUser
}

export default connect(null, mapDispatchToProps)(ModalEditProfil)
